import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import WixSDK from 'shared/utils/wix-sdk';


const ACTIONS = createAsyncActions('SERVER.USERS.CURRENT-SITE-USER');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;


export default function () {
  return function (dispatch) {
    dispatch(START());

    return WixSDK.currentMember()
      .then(
        function (currentUserData) {
          dispatch(SUCCESS({}, currentUserData));
          return currentUserData;
        },

        function (response) {
          dispatch(FAIL({}, response));
        }
      );
  };
}



// WEBPACK FOOTER //
// ./src/widget/redux/server/actions/current-site-user/get.js